// Родительский замок (К-16, FR-KID-02): удержание 3 с + пример на умножение — недоступно пятилетнему.
import { useEffect, useMemo, useRef, useState } from "react";
import { t } from "../i18n/ru.ts";

function makeTask() {
  const a = 3 + Math.floor(Math.random() * 7);
  const b = 3 + Math.floor(Math.random() * 7);
  const right = a * b;
  const set = new Set([right]);
  while (set.size < 3) set.add(right + (Math.floor(Math.random() * 9) - 4 || 5));
  return { a, b, right, options: [...set].sort((x, y) => x - y) };
}

export function ParentGate({ onPass, onCancel, holdSec = 3 }: { onPass: () => void; onCancel: () => void; holdSec?: number }) {
  const [held, setHeld] = useState(false);
  const [progress, setProgress] = useState(0);
  const [wrong, setWrong] = useState(false);
  const task = useMemo(makeTask, []);
  const timer = useRef<number | null>(null);
  const start = useRef(0);
  useEffect(() => () => {
    if (timer.current) cancelAnimationFrame(timer.current);
  }, []);
  const down = () => {
    start.current = performance.now();
    const tick = () => {
      const p = (performance.now() - start.current) / (holdSec * 1000);
      setProgress(Math.min(1, p));
      if (p >= 1) setHeld(true);
      else timer.current = requestAnimationFrame(tick);
    };
    timer.current = requestAnimationFrame(tick);
  };
  const up = () => {
    if (timer.current) cancelAnimationFrame(timer.current);
    if (!held) setProgress(0);
  };
  return (
    <div className="gate" role="dialog" aria-modal="true" aria-label={t.gate.title}>
      <div className="gate__box">
        <h2>{t.gate.title}</h2>
        {!held ? (
          <button className="gate__hold" onPointerDown={down} onPointerUp={up} onPointerLeave={up} onContextMenu={(e) => e.preventDefault()}>
            <span className="gate__ring" style={{ ["--p" as string]: progress }} />
            {t.gate.hold}
          </button>
        ) : (
          <>
            <p className="gate__q">{t.gate.question(task.a, task.b)}</p>
            <div className="gate__opts">
              {task.options.map((o) => (
                <button key={o} className="btn" onClick={() => (o === task.right ? onPass() : setWrong(true))}>
                  {o}
                </button>
              ))}
            </div>
            {wrong ? <p className="muted">{t.gate.wrong}</p> : null}
          </>
        )}
        <button className="link" onClick={onCancel}>
          {t.common.cancel}
        </button>
      </div>
    </div>
  );
}
